/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Slug_HintInputs */

const vi_shop_slug_hint = /** @type {(inputs: Shop_Slug_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Để trống tự sinh từ tên. Đổi slug làm hỏng link cũ.`)
};

/**

* @param {Shop_Slug_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_slug_hint = /** @type {((inputs?: Shop_Slug_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Slug_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_slug_hint(inputs)
});